// tslint:disable
export enum DebitCardVmcUsageRegion {
    /**
     * @description Unknown
     */
    Unknown = 0,
    /**
     * @description USA
     */
    USA = 1,
    /**
     * @description international
     */
    international = 2,
}
(DebitCardVmcUsageRegion as any)['UNKNOWN'] = 0;
(DebitCardVmcUsageRegion as any)['INTERNATIONAL'] = 2;
